export default __webpack_public_path__ + "static/media/imould.3291ff9a.png";